import React, { Fragment, useContext, useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Dropdown } from "semantic-ui-react";
import { BasicContext } from "../../App";
import { postMethod } from "../../requests";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/free-solid-svg-icons";

const ClassLevelsDropdown = (props) => {
    const { onChange, value, multiple, classN, req, id, disabled, small, clearable } = props;
    const { t } = useTranslation();
    const { checkServerData } = useContext(BasicContext);
    const [list, setList] = useState(null);
    const [loading, setLoading] = useState(true);

    const getClassLevels = async () => {
        const res = await postMethod("/get-classes-levels");
        if (checkServerData(res)) {
            const list = [],
                lvlList = res.data.levels;
            lvlList.forEach((e, i) => {
                list.push({
                    key: i,
                    value: e.class_level_code,
                    text: (
                        <>
                            {e.class_level_name}
                            <FontAwesomeIcon icon={faCircle} className={`ms-2 class-lvl-${e.class_level_colour}`} />
                        </>
                    ),
                });
            });
            setList(list);
        }
    };

    useEffect(() => {
        if (list) setLoading(false);
        // eslint-disable-next-line
    }, [list]);

    useEffect(() => {
        getClassLevels();
        // eslint-disable-next-line
    }, []);

    return (
        <Fragment>
            <Form.Group className={classN ? classN : "mb-3"}>
                <Form.Label>
                    {t(`classes.classesLevel${multiple ? "s" : ""}`)} {req && <span className="text-danger">*</span>}
                </Form.Label>
                {loading ? (
                    <p>{t("loadingData")}</p>
                ) : (
                    <Dropdown
                        placeholder={multiple ? t("chooseMany") : t("choose")}
                        fluid
                        multiple={multiple}
                        selection
                        options={list}
                        onChange={(e, data) => onChange(data.value)}
                        value={value}
                        id={id}
                        className={small && "form-control-sm"}
                        disabled={disabled}
                        clearable={clearable}
                    />
                )}
            </Form.Group>
        </Fragment>
    );
};

export default ClassLevelsDropdown;
